import { css } from 'emotion';
import { colors } from '@joykit/variables';

export namespace styles {
  export const container = (scrolling: boolean) =>
    css(
      {
        position: 'fixed',
        boxSizing: 'border-box',
        WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)',
        zIndex: 1500,
        top: '0px',
        left: '0px',
        width: '100%',
        height: '100%',
        padding: '1em 0',
        overflow: 'auto',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        '::-webkit-scrollbar': {
          width: 8
        },
        '::-webkit-scrollbar-thumb': {
          backgroundColor: colors.gray
        }
      },
      scrolling
        ? {
            justifyContent: 'flex-start'
          }
        : undefined
    );
}
